import { Action } from '../../../action';
import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setGetDetalization = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_DETALIZATION_INFORMATION
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetDetalizationAction(data.data))
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetDetalization as SetGetDetalization
}